import { Moment } from 'moment';
import { QuestionBase } from './question-base';

export class DatepickerQuestion extends QuestionBase<Moment> {
  controlType = 'datepicker';
}
